import { call, put, takeLatest } from "redux-saga/effects";
import {
  FETCH_USERUNINSTALL_REQUEST,
  fetchUninstallFailure,
  fetchUninstallSuccess,
  SEARCH_USERUNINSTALL_REQUEST,
  searchUninstallSurveySuccess,
  searchUninstallSurveyFailure

} from "./uninstallAction";
import SDK from "../../config";

function* fetchUninstallData(action) {
  const { page, limit } = action.payload;
  try {
    const response = yield call(fetch, `${SDK.SOCKET_URL}/user/uninstall/survey?page=${page}&limit=${limit}`);
    console.log(response);
    
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data = yield response.json();
    yield put(fetchUninstallSuccess(data.data));
  } catch (error) {
    console.error("Error fetching data:", error);
    yield put(fetchUninstallFailure(error.toString()));
  }
}

// Search Uninstall Survey data saga
function* searchUninstallSurvey(action) {
  const { searchTerm } = action.payload;
  try {
    const response = yield call(fetch, `${SDK.SOCKET_URL}/search/uninstall/survey?searchTerm=${searchTerm}`);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = yield response.json();
    yield put(searchUninstallSurveySuccess(data.data));
  } catch (error) {
    console.error('Fetch error:', error);
    yield put(searchUninstallSurveyFailure(error.toString()));
  }
}

function* getUninstallSaga() {
  yield takeLatest(FETCH_USERUNINSTALL_REQUEST, fetchUninstallData);
  yield takeLatest(SEARCH_USERUNINSTALL_REQUEST, searchUninstallSurvey)
}

export default getUninstallSaga;
